import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TherapistService} from '../../../services/therapist.service';

export interface IMeasureItem {
    title: string;
    subtitle: string;
    name: string;
    description: string;
    type: string;
    duration: number;
    text: string;
}

@Component({
    selector: 'app-new-client-session',
    templateUrl: './new-client-session.component.html',
    styleUrls: ['./new-client-session.component.scss']
})
export class NewClientSessionComponent implements OnInit {

    form: FormGroup = new FormGroup({});
    selectedClients = [];
    selectedMeasures = [];
    measures = [];
    measuresPage = [];

    constructor(
        private fb: FormBuilder,
        private service: TherapistService
    ) {
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            clientName: [null, Validators.required],
            email: [null, Validators.email],
            link: [],
        });

        this.service.getMeasurements()
            .subscribe((res: { total: number, items: IMeasureItem[] }) => {
                this.measures = res.items;
                console.log(this.measures);
            });
    }

    addClient() {
        this.selectedClients.push(this.form.value);
        this.form.reset();
    }

    removeClient(i: number) {
        this.selectedClients.splice(i, 1);
    }

    removeMeasure(i: number) {
        this.selectedMeasures.splice(i, 1);
    }

    addMeasure(item: any) {
        this.selectedMeasures.push(item);
    }

    isItemSelected(item: IMeasureItem) {
        return this.selectedMeasures.find((el: IMeasureItem) => el.name === item.name);
    }

    addMeasures() {
    }

    get addMeasureDisabled() {
        return !this.selectedMeasures.length;
    }

    onPager(prop) {
        this.measuresPage = prop;

    }
}
